import { Box, Card, Typography } from '@mui/material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { C, SX, TYPE } from './tokens';

/**
 * Lifted out of pages/WebHooks/MerchantConfig.js, which was the only screen in
 * Merchant Setup with a real empty state -- everywhere else rendered a bare
 * empty data grid and left the user guessing whether it was loading, broken, or
 * genuinely empty.
 *
 * @param title    what is missing, in the user's words
 * @param body     what to do about it
 * @param icon     override the storefront glyph
 * @param action   optional node (button / link)
 */
export default function EmptyState({ title = 'No merchant selected', body = 'Pick a merchant above to see and edit its settings.', icon, action, dense = false }) {
    return (
        <Card elevation={0} sx={{ ...SX.cardFlush, textAlign: 'center', py: dense ? 4 : 7, px: 3 }}>
            <Box sx={{
                width: 46, height: 46, mx: 'auto', mb: 1.75,
                display: 'grid', placeItems: 'center',
                borderRadius: '50%', bgcolor: C.surfaceAlt, color: C.inkGhost,
            }}>
                {icon || <StorefrontOutlinedIcon sx={{ fontSize: 24 }} />}
            </Box>
            <Typography sx={{ ...TYPE.sectionTitle, mb: 0.5 }}>{title}</Typography>
            <Typography sx={{ ...TYPE.rowHelp, maxWidth: 380, mx: 'auto' }}>{body}</Typography>
            {action && <Box sx={{ mt: 2.5 }}>{action}</Box>}
        </Card>
    );
}
